import { useState } from "react";

import Button from "react-bootstrap/Button";
import { SketchPicker } from "react-color";

interface ColorPickerProps {
  value: string;
  label: string;
  onChange: (value: string | undefined | null) => void;
}

const ColorPicker = (props: ColorPickerProps) => {
  const { value, label, onChange } = props;

  const [visible, setVisible] = useState(false);

  return (
    <div className="d-flex flex-column">
      {/* <Button onClick={() => setVisible(true)}>{label}</Button> */}
      <div className="d-flex flex-row align-items-center my-1">
        <label className="mb-0 mr-3">
          {/* {value ? `Hex: ${value}` : "No color selected"} */}
          {label}
        </label>
        <Button
          style={{
            backgroundColor: value || "transparent",
            width: "1.5rem",
            height: "1.5rem",
            border: ".1rem solid",
            borderColor: value ? "#000" : "#ccc",
          }}
          onClick={() => setVisible(true)}
        />
        {value && (
          <Button
            variant="outline-secondary"
            size="sm"
            className="ml-4 py-0"
            onClick={() => onChange(null)}
          >
            Clear
          </Button>
        )}
      </div>
      {visible && (
        <div className="position-absolute z-index-2">
          <div
            className="position-fixed top-0 bottom-0 left-0 right-0"
            onClick={() => setVisible(false)}
          />
          <SketchPicker
            color={value}
            onChangeComplete={({ hex }) => {
              onChange(hex);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
